import * as zod from "zod";

export enum EStatusClassificacaoArtigo {
    Ativo = 1,
    Inativo = 2,
}

export interface ClassificacaoArtigoVm {
    id: number;
    tipo: number;
    tipoDescricao: string;
    descricao: string;
    prefixo: string;
    cor: string;
    status: EStatusClassificacaoArtigo;
    statusDescricao: string;
}

export interface TipoClassificacaoArtigoVm {
    id: number;
    descricao: string;
}

export const zodClassificacaoArtigoVm = zod.object({
    id: zod.number(),
    tipo: zod.number(),
    tipoDescricao: zod.string(),
    descricao: zod.string(),
    prefixo: zod.string(),
    cor: zod.string(),
    status: zod.number(),
    statusDescricao: zod.string(),
}, {message: "Selecione uma classificação"}).refine((val) => val != null);

export const zodTipoClassificacaoArtigoVm = zod.object({
    id: zod.number(),
    descricao: zod.string(),
}, {message: "Selecione um tipo"}).refine((val) => val != null);

// Classificações sincronizadas automaticamente do Sigest via trigger MySQL (Produto Acabado,
// Dispositivo de Produção, Dispositivo de Controle) — ver SYNC_LEGADO_ARTIGO.md no backend. Cadastro,
// alteração e remoção de Artigo nessas classificações é bloqueado no Prisma; espelha
// ClassificacaoArtigoLegadoHelper.EhSincronizadaDoLegado (backend, ArtigoCtx/Helpers).
const IDS_CLASSIFICACAO_ARTIGO_SINCRONIZADOS_DO_LEGADO = [1, 7, 8];

export function classificacaoArtigoEhSincronizadaDoLegado(classificacaoArtigoId: number | null | undefined): boolean {
    return classificacaoArtigoId != null && IDS_CLASSIFICACAO_ARTIGO_SINCRONIZADOS_DO_LEGADO.includes(classificacaoArtigoId);
}
